<div class="persistent-rich-text-section">
  <app-rich-text-section #textSectionComponent *ngIf="loaded" [(text)]="text" [readOnly]="true"
    [editAvailable]="editAvailable" [editToggleAvailable]="editToggleAvailable" [actions]="actions"
    [textTransformer]="textTransformer">
  </app-rich-text-section>
</div>